import React from "react";

import SourceThread from "./SourceThread";
import UserThread from "./UserThread";
import "../../../css/admin/comments.scss";

import type { JSX } from "react";

import type { CommentSource, CommentUser } from "../comment.types";

interface CommentThreadProps {
  main?: boolean;
  source?: CommentSource;
  text?: string;
  user?: CommentUser;
}

function CommentThread({
  main = false,
  source,
  text,
  user,
}: CommentThreadProps): JSX.Element {
  return (
    <div
      className={`editor-comment-thread-container editor-tile-container ${main ? "main-comment" : ""} m-1!`}
    >
      {user?.uuid ? <UserThread user={user} /> : null}
      {text ? <div className="comment-thread-text">{text}</div> : null}
      {main && source?.uuid ? <SourceThread source={source} /> : null}
    </div>
  );
}

export default CommentThread;
